/**
 * i18n Provider
 *
 * Internationalization provider for React Admin.
 * Supports multiple languages with automatic browser detection.
 */

import polyglotI18nProvider from 'ra-i18n-polyglot';
import en from '@/i18n/en';
import es from '@/i18n/es';

const translations: Record<string, any> = {
  en,
  es,
};

const DEFAULT_LOCALE = 'en';

export const i18nProvider = polyglotI18nProvider(
  (locale) => translations[locale] || translations[DEFAULT_LOCALE],
  DEFAULT_LOCALE,
  [
    { locale: 'en', name: 'English' },
    { locale: 'es', name: 'Español' },
  ]
);

export default i18nProvider;
